export function friendlyPhoneFormat(phone) {
    if (!phone) {
        return '';
    }
    return phone
        ? phone.toString().replace(/(\d{3})(\d{3})(\d{2,4})/, '+1 ($1) $2-$3')
        : phone.toString();
}
